module.exports = __webpack_public_path__ + "h5/img/certification1.7ee4c1e9.png";